import { render, staticRenderFns } from "./FamousEditHistoryItem.vue?vue&type=template&id=e9682736&"
import script from "./FamousEditHistoryItem.vue?vue&type=script&lang=js&"
export * from "./FamousEditHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports